'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.getPayment = getPayment;
exports.setPaymentId = setPaymentId;
exports.getPaymentsParamsFromPIPObyId = getPaymentsParamsFromPIPObyId;
exports.paymentIbonus = paymentIbonus;
exports.checkCodeSendForPaymentIbonus = checkCodeSendForPaymentIbonus;
exports.resetPaymentIbonus = resetPaymentIbonus;
exports.loadProcessInput = loadProcessInput;
exports.resetProcessInput = resetProcessInput;
exports.setCustomPayment = setCustomPayment;
exports.resetCustomPayment = resetCustomPayment;
exports.rePaymentByOrder = rePaymentByOrder;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPayment() {
    return {
        types: [_constants.PaymentConstants.SHOW, _constants.PaymentConstants.SHOW_SUCCESS, _constants.PaymentConstants.SHOW_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getPayment();
        }
    };
}

function setPaymentId(id) {
    return {
        type: _constants.Personal.OrderDetail.SET_PAYMENT_ID,
        paymentId: id
    };
}

function getPaymentsParamsFromPIPObyId(pipoShopId) {
    return {
        types: [_constants.PaymentConstants.PIPO_PAY_PARAMS_REQUEST, _constants.PaymentConstants.PIPO_PAY_PARAMS_SUCCESS, _constants.PaymentConstants.PIPO_PAY_PARAMS_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getPaymentsParamsFromPIPObyId(pipoShopId);
        }
    };
}

/**
 * Оплата методами айбонуса
 */
function paymentIbonus(accountId, operationId) {
    var checkCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return {
        types: [_constants.PaymentConstants.PAY_INNER_PIPO_REQUEST, _constants.PaymentConstants.PAY_INNER_PIPO_SUCCESS, _constants.PaymentConstants.PAY_INNER_PIPO_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.payInnerPipo(accountId, operationId, checkCode);
        }
    };
}

function checkCodeSendForPaymentIbonus() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var online_shop_id = arguments[1];
    var orderId = arguments[2];

    return {
        types: [_constants.PaymentConstants.CHECK_CODE_SEND_INNER_PIPO_REQUEST, _constants.PaymentConstants.CHECK_CODE_SEND_INNER_PIPO_SUCCESS, _constants.PaymentConstants.CHECK_CODE_SEND_INNER_PIPO_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.checkCodeConfirmForPayInnerPipo(online_shop_id, orderId).then(function (result) {
                if (callback) {
                    callback(Boolean(result.secure));
                }

                return result;
            });
        }
    };
}

function resetPaymentIbonus() {
    return {
        type: _constants.PaymentConstants.PAY_INNER_PIPO_RESET
    };
}

function loadProcessInput(operation_id, group_slug) {
    var additionalFieldName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var additionalFieldText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    return {
        types: [_constants.PaymentConstants.PIPO_PROCESS_INPUT_REQUEST, _constants.PaymentConstants.PIPO_PROCESS_INPUT_SUCCESS, _constants.PaymentConstants.PIPO_PROCESS_INPUT_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.pipoProcessInput(operation_id, group_slug, additionalFieldName, additionalFieldText).then(function (result) {
                return (0, _extends3.default)({}, result, {
                    slug: group_slug
                });
            });
        }
    };
}

function resetProcessInput() {
    return {
        type: _constants.PaymentConstants.PIPO_PROCESS_INPUT_RESET
    };
}

function setCustomPayment() {
    return {
        type: _constants.PaymentConstants.SET_CUSTOM_PAYMENT
    };
}

function resetCustomPayment() {
    return {
        type: _constants.PaymentConstants.RESET_CUSTOM_PAYMENT
    };
}

function rePaymentByOrder(orderId, callback) {
    return {
        types: [_constants.PaymentConstants.REPAYMENT_ORDER_REQUEST, _constants.PaymentConstants.REPAYMENT_ORDER_SUCCESS, _constants.PaymentConstants.REPAYMENT_ORDER_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.paymentCreate(orderId).then(function (result) {
                if (callback) {
                    callback(result);
                }
                return result;
            });
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/payment.js
// module id = 114
// module chunks = 0